module.exports = __webpack_public_path__ + "static/media/EPS-FUSDT.73dcc3b2.png";